import { CatalogBuilder } from "../../../commonGroupModuleStructure/catalogBuilder";
import { deleteMenu, getMenuPaging, getMenuTree } from "./apiCall";
import { MenuKeys } from "./entity";

export const MenuUser = (props: any) => {
  const listOfMenuUserColums = [
    {
      field: "DisplayName",
      headerName: "Display Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "ModuleName",
      headerName: "Module Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    }
  ];

  return (
    <CatalogBuilder
      headerLabel="Menu"
      headerButtonLabel="Add Menu"

      getPagingData={getMenuPaging}
      pagingAPIKey={MenuKeys.paging}

      onDelete={deleteMenu}
      deletePagingAPIKey={MenuKeys.delete}

      getTreeData={getMenuTree}
      treeApiKey={MenuKeys.tree}
      treeViewLabel="Features > FeatureAccess"

      onModeClickPath="/menu/details/"
    />
  );
};
